import { render, staticRenderFns } from "./Mock.vue?vue&type=template&id=6577565a&scoped=true&lang=html&"
import script from "./Mock.vue?vue&type=script&lang=ts&"
export * from "./Mock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6577565a",
  null
  
)

export default component.exports